





























































































































import { Component, Vue } from "@/shared/vuepack";

@Component({
  components: {
  }
})
export default class RuleHelp extends Vue {
}
